/**
 * Created by Bart Decorte
 * Date: 09/11/2018
 * Time: 12:18
 */
import UsersManipulate from './UsersManipulate';
import UserSelect from './_partials/UserSelect';

class UsersAdd extends UsersManipulate {
  constructor() {
    super();
    const element = document.querySelector('#user');
    const userSelect = new UserSelect(element);
    this.bindKeys(this.keyBindings());
  }
}

export default UsersAdd;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/UsersAdd.js